// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_ZhShb { 
  padding : 0 0;
}

.contentHeader_MFA3t {
  padding : 12px 24px;
}

.row_NsZu0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.search_DtIH8 {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.header_qwqUa {
  display: flex;
}
.flexRight_KTUR1 {
  margin-left: auto;
}
.perPageDropdown_G4VaH{
  min-width: 75px;
}
.left_uCOTz {
  height: 100%;
}
.pagination_bZohf { 
  border-top : 1px solid var( --lighter-grey );
  background: white;
  position:absolute;
  bottom : 0;
  margin : 0;
  height : 40px;
  width : 100%;
  display: flex;
  justify-content:center;
  align-items:center;

  .innerPagination_tVBBa {
    margin : 0
  }
}
.header_qwqUa {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/
}

.list_a6ykc {
  height: 100%;
  width: 100%;
  border:1px solid var( --lighter-grey );
}

.left_uCOTz {
  margin-right: auto;
}

.right_j9n43 {
  margin-left: auto;
}

.icon_x4hsz {
  background-color: var( --purple );
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  margin-left: 0;
  .textTop_DLC4e {
    vertical-align: text-top;
  }
}

.splitRight_sdKSM {
  width: 450px;
  height: 100%;
  background : var( --background );
}
.stopTimer_NMQKp i {
  color: var( --red );
}
.deleteTimer_W1a4S i {
  color: var( --grey )
}
.editor_gPxmv {
  height: 100%;
}

.filter_kPNJ0 {
  display : flex;
  flex-direction: row;
  width: 100%;
}

.center_LwWlW {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .loadMore_YiC0V {
    color: var( --purple );
    margin-right: 10px;
  }
}

.addTypeButton_e1HFR {
  text-align: center;
  user-select: none;
}

.addTypeButton_e1HFR:hover {
  background: var( --purple-5 );
}
.addTypeButton_e1HFR:active {
  background: var( --purple-15 );
}

.addTypeButton_e1HFR p {
  text-align: justify;
  font-weight: 300;
}
.addTypeButton_e1HFR > i {
  font-size:36px;
  color : var( --light-grey );
  border : 7px solid var( --light-grey );    
  border-radius: 50%;
  padding: 20px;
  width: 90px;
  height: 90px;
  margin: 10px;
}

.addTypeButton_e1HFR:hover > i {
  color : var( --purple );
  border-color : var( --purple );
}
`, "",{"version":3,"sources":["webpack://./src/screens/templates/TemplatesScreen.css"],"names":[],"mappings":"AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB;IACE;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;AACvE;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC","sourcesContent":["@import \"../../style/theme.css\";\n\n.content { \n  padding : 0 0;\n}\n\n.contentHeader {\n  padding : 12px 24px;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.search {\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.perPageDropdown{\n  min-width: 75px;\n}\n.left {\n  height: 100%;\n}\n.pagination { \n  border-top : 1px solid var( --lighter-grey );\n  background: white;\n  position:absolute;\n  bottom : 0;\n  margin : 0;\n  height : 40px;\n  width : 100%;\n  display: flex;\n  justify-content:center;\n  align-items:center;\n\n  .innerPagination {\n    margin : 0\n  }\n}\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n}\n\n.list {\n  height: 100%;\n  width: 100%;\n  border:1px solid var( --lighter-grey );\n}\n\n.left {\n  margin-right: auto;\n}\n\n.right {\n  margin-left: auto;\n}\n\n.icon {\n  background-color: var( --purple );\n  color: white;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 5px;\n  margin-left: 0;\n  .textTop {\n    vertical-align: text-top;\n  }\n}\n\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background : var( --background );\n}\n.stopTimer i {\n  color: var( --red );\n}\n.deleteTimer i {\n  color: var( --grey )\n}\n.editor {\n  height: 100%;\n}\n\n.filter {\n  display : flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  .loadMore {\n    color: var( --purple );\n    margin-right: 10px;\n  }\n}\n\n.addTypeButton {\n  text-align: center;\n  user-select: none;\n}\n\n.addTypeButton:hover {\n  background: var( --purple-5 );\n}\n.addTypeButton:active {\n  background: var( --purple-15 );\n}\n\n.addTypeButton p {\n  text-align: justify;\n  font-weight: 300;\n}\n.addTypeButton > i {\n  font-size:36px;\n  color : var( --light-grey );\n  border : 7px solid var( --light-grey );    \n  border-radius: 50%;\n  padding: 20px;\n  width: 90px;\n  height: 90px;\n  margin: 10px;\n}\n\n.addTypeButton:hover > i {\n  color : var( --purple );\n  border-color : var( --purple );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_ZhShb`,
	"contentHeader": `contentHeader_MFA3t`,
	"row": `row_NsZu0`,
	"search": `search_DtIH8`,
	"header": `header_qwqUa`,
	"flexRight": `flexRight_KTUR1`,
	"perPageDropdown": `perPageDropdown_G4VaH`,
	"left": `left_uCOTz`,
	"pagination": `pagination_bZohf`,
	"innerPagination": `innerPagination_tVBBa`,
	"list": `list_a6ykc`,
	"right": `right_j9n43`,
	"icon": `icon_x4hsz`,
	"textTop": `textTop_DLC4e`,
	"splitRight": `splitRight_sdKSM`,
	"stopTimer": `stopTimer_NMQKp`,
	"deleteTimer": `deleteTimer_W1a4S`,
	"editor": `editor_gPxmv`,
	"filter": `filter_kPNJ0`,
	"center": `center_LwWlW`,
	"loadMore": `loadMore_YiC0V`,
	"addTypeButton": `addTypeButton_e1HFR`
};
export default ___CSS_LOADER_EXPORT___;
